<script setup>
const props = defineProps({
  model: {
    type: Object,
    default: () => ({}),
  },
})

const title = computed(() => props.model?.title?.value)
const items = computed(() => props.model?.questionCategories?.expandedValue || [])
const body = computed(() => props.model?.body?.value)
// Optimizely serializes an unchecked PropertyBoolean as null, never false
const firstRowFull = computed(() => props.model?.firstRowFull?.value === true)
const removeIcons = computed(() => props.model?.removeIcons?.value === true)
const showFeaturedFirst = computed(() => firstRowFull.value && items.value.length !== 2)
</script>

<template>
  <!-- Question Category Block -->
  <section class="question-category-block block-spacing mx-auto w-full container-text eight-col-max">
    <div class="question-category-block__header prose mb-3">
      <h2
        v-if="title"
        class="question-category-block__title text-2xl font-bold mb-2 text-pretty"
      >
        {{ title }}
      </h2>

      <div
        v-if="body"
        v-html="body"
      />
    </div>

    <div class="question-category-block__items">
      <ULink
        v-for="(item, index) in items"
        :key="index"
        :to="useCmsUrl(item.url)"
        :locale="false"
        class="question-category-block__item rounded-xl px-6 py-8 xl:p-10 shadow-[0px_4px_20px_0px_rgba(0,0,0,0.15)] hover:shadow-[0px_4px_20px_0px_rgba(0,0,0,0.25)]"
        :class="{ 'featured-item': showFeaturedFirst && index === 0 }"
      >
        <div
          v-if="!removeIcons && item?.aprimoCategoryIcon?.url"
          class="question-category-block__item-media"
        >
          <NuxtImg
            provider="fastlyAprimo"
            :src="item?.aprimoCategoryIcon?.url"
            class="h-auto"
            :class="showFeaturedFirst ? 'w-20' : 'w-24'"
            :alt="item?.categoryIconAltText?.value"
            :width="item?.aprimoCategoryIcon?.width ?? 80"
            :height="item?.aprimoCategoryIcon?.height ?? 80"
          />
        </div>
        <div class="question-category-block__item-body">
          <span class="question-category-block__item-title underline font-bold text-primary">
            {{ item?.pageTitle?.value }}
          </span>

          <p
            v-if="item?.categorySubhead?.value"
            class="question-category-block__item-description mt-3 text-med-navy"
          >
            {{ item?.categorySubhead?.value }}
          </p>
        </div>
      </ULink>
    </div>
  </section>
</template>

<style lang="scss">
@use '@/assets/css/blocks/question-category-block.scss';
</style>
